import { ReactElement } from 'react';
import { Message, useMessage } from '@messageformat/react';
import { space } from '@op/opds.tokens';
import { ReactComponent as Image035 } from '../images/OP_symbolikuvitus_128_035.svg';
import FullWidthHighlightSection from './FullWidthHighlightSection';

interface Props {
  title: string;
  messageId: string;
}

const HighlightedList = (props: Props): ReactElement => {
  const { title, messageId } = props;
  const messageArray = useMessage(messageId);

  return (
    <FullWidthHighlightSection>
      <Image035 className="investoracademy-small-svg" aria-hidden="true" />
      <h2
        className="opds-styles-v1-text-title-small-strong"
        style={{
          textAlign: 'center',
          marginTop: space.xxs,
        }}
      >
        <Message id={title} />
      </h2>
      <ul>
        {Object.entries(messageArray).map(([key, value]) => {
          const indexValue = parseInt(key, 10) + 1;
          const messageFunc = value as () => string;
          return (
            <li
              key={key}
              className="opds-styles-v1-text-body-medium"
              style={{
                gap: '2rem',
                paddingTop: space.xs,
                display: 'flex',
                alignItems: 'center',
                maxWidth: '50rem',
              }}
            >
              <div className="investoracademy-number">{indexValue}</div>
              <span>{messageFunc()}</span>
            </li>
          );
        })}
      </ul>
    </FullWidthHighlightSection>
  );
};

export default HighlightedList;
